import { shoppingCartAPI } from "services/swagger-api";
import { MainBorrowerPricingSyncActions } from "../types";

export const createBorrowerCartItem = async (
  funnelId: string,
  groupContractId: string,
  borrowerIds: Array<string>,
  isGroup: boolean,
  borrowerProjectId: string,
  contractFunnelHash: string,
  actions: MainBorrowerPricingSyncActions,
) => {
  actions.setLoading(true)
  try {
    const response = await shoppingCartAPI.addBorrowerToCartSecure({
      addBorrowerToCartSecureCommand: {
        contractFunnelHash,
        funnelId,
        borrowerProjectId,
        borrowerIds,
        isGroup,
        groupContractId,
      }
    })
    if (response.items)
      actions.updateShoppingCart(response.items)
  } catch (error) {
    console.error(error)
  } finally {
    actions.setLoading(false)
  }
}
